(() => {
  if (window.tkPostHogInstalled || window.Shopify?.designMode) return;
  if (!['talithakoum.com', 'www.talithakoum.com'].includes(location.hostname)) return;
  if (/\/(account|checkouts?|orders)(\/|$)/.test(location.pathname)) return;
  window.tkPostHogInstalled = true;
  const token = 'phc_vmFzVPMMtwJGZfQWeGCEEZdcFfYnUr7r94H4WN3QGGuV';
  const idCookie = 'tk_ph_distinct_id';
  const sessionCookie = 'tk_ph_session_id';
  let loading = false;
  let ready = false;
  let active = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const readCookie = (name) => document.cookie.split('; ').find((part) => part.startsWith(name + '='))?.substring(name.length + 1);
  function cookie(name, value, age = 31536000) {
    document.cookie = `${name}=${value}; Path=/; Max-Age=${age}; SameSite=Lax; Secure`;
  }
  function safeUrl(value) {
    try {
      const url = new URL(value, location.origin);
      if (/\/(account|checkouts?|orders)(\/|$)/.test(url.pathname)) return url.origin + '/[private]';
      return url.origin + url.pathname;
    } catch { return ''; }
  }
  function scrub(event) {
    if (!allowed()) return null;
    const props = event.properties || {};
    if (props.$session_id) syncSession(props.$session_id);
    for (const key of ['$current_url', '$referrer', '$initial_current_url', '$initial_referrer']) {
      if (props[key]) props[key] = safeUrl(props[key]);
    }
    for (const group of ['$set', '$set_once']) {
      for (const key of Object.keys(props[group] || {})) {
        if (/url|referrer/.test(key)) props[group][key] = safeUrl(props[group][key]);
      }
    }
    return event;
  }
  function syncSession(sessionId) {
    if (allowed()) cookie(sessionCookie, sessionId, 1800);
  }
  const context = document.querySelector('script[data-tk-posthog]')?.dataset || {};
  let cartState = JSON.stringify({ ph_session_id: context.cartSession || '', ph_distinct_id: context.cartDistinct || '', ph_replay_url: context.cartReplay || '' });
  let cartPending = false;
  function cartAttributes() {
    const sdk = window.posthog;
    return allowed() && ready ? {
      ph_session_id: sdk.get_session_id(),
      ph_distinct_id: sdk.get_distinct_id(),
      ph_replay_url: safeUrl(sdk.get_session_replay_url())
    } : { ph_session_id: '', ph_distinct_id: '', ph_replay_url: '' };
  }
  async function syncCart() {
    if (cartPending) return;
    const next = JSON.stringify(cartAttributes());
    if (next === cartState) return;
    cartPending = true;
    try {
      const response = await fetch((window.Shopify.routes?.root || '/') + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: JSON.parse(next) })
      });
      if (!response.ok) throw new Error('Cart attribution rejected');
      cartState = next;
    } catch {
      console.warn('Talitha Koum analytics could not update cart attribution.');
    } finally {
      cartPending = false;
      if (JSON.stringify(cartAttributes()) !== next) syncCart();
    }
  }
  let behaviorInstalled = false;
  function installBehavior() {
    if (behaviorInstalled) return;
    behaviorInstalled = true;
    const capture = (name, properties = {}) => {
      if (ready && allowed()) window.posthog.capture(name, properties);
    };
    const product = context.productId ? { product_id: context.productId, product_handle: context.productHandle } : {};
    const atcSelector = '[data-btn-addToCart], .csph__btn--cart, .tkp-card__btn--cart, .tk-subscribe-option, form[action$="/cart/add"] [name="add"]';
    if (context.productId) {
      capture('pdp_view', product);
      let engaged = false;
      const depths = new Set();
      const engage = (via) => {
        if (engaged || document.hidden || !allowed()) return;
        engaged = true;
        capture('pdp_engaged', { ...product, via });
      };
      let visibleSeconds = 0;
      const timer = setInterval(() => {
        if (allowed() && !document.hidden) visibleSeconds++;
        if (visibleSeconds >= 15) { engage('visible_15s'); clearInterval(timer); }
      }, 1000);
      window.addEventListener('scroll', () => {
        if (!allowed()) return;
        const height = document.documentElement.scrollHeight - window.innerHeight;
        if (height <= 0) return;
        const percent = Math.min(100, Math.round(window.scrollY / height * 100));
        for (const depth of [25, 50, 75, 100]) {
          if (percent >= depth && !depths.has(depth)) {
            depths.add(depth); capture('pdp_scroll', { ...product, depth });
          }
        }
        if (percent >= 50) engage('scroll_50');
      }, { passive: true });
      const atc = document.querySelector('.csph__btn--cart') || document.querySelector('#product-add-to-cart');
      if (atc && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (allowed() && entries.some(entry => entry.isIntersecting)) {
            capture('atc_visible', product); observer.disconnect();
          }
        }, { threshold: 0.5 });
        observer.observe(atc);
      }
    }
    document.addEventListener('click', (event) => {
      const target = event.target.closest?.('a, button, input[type="submit"]');
      if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
      if (target.matches(atcSelector)) {
        const form = target.form || target.closest('form');
        const variant = target.getAttribute('data-variant-id') || form?.querySelector('[name="id"]')?.value;
        const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
        capture('atc_click', { ...product, variant_id: /^\d+$/.test(variant || '') ? variant : undefined, quantity });
      }
      const href = target.getAttribute('href') || '';
      if (target.matches('[name="checkout"], button.btn-checkout, a.btn-checkout') || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:[/?]|$)/i.test(href)) {
        capture('checkout_click'); syncCart();
      }
    }, true);
    function added(result) {
      if (!allowed()) return;
      for (const item of (result?.items || (result?.variant_id ? [result] : []))) {
        capture('add_to_cart', { product_id: item.product_id, variant_id: item.variant_id, product_handle: item.handle, line_quantity: item.quantity, price: (item.final_price ?? item.price) / 100, currency: context.currency });
      }
      syncCart();
    }
    document.addEventListener('tk:cart-added', event => added(event.detail));
    if (window.jQuery) {
      window.jQuery(document).on('ajaxSuccess.tkPostHog', (_event, xhr, settings, data) => {
        if (!allowed()) return;
        let url;
        try { url = new URL(settings.url, location.origin); } catch { return; }
        if (url.origin !== location.origin || !/\/cart\/add\.js$/.test(url.pathname)) return;
        added(data || xhr.responseJSON);
      });
    }
  }
  function syncConsent() {
    if (!allowed()) {
      if (ready) window.posthog.opt_out_capturing();
      cookie(idCookie, '', 0);
      cookie(sessionCookie, '', 0);
      active = false;
      syncCart();
      return;
    }
    if (ready) {
      if (!active) {
        window.posthog.opt_in_capturing({ captureEventName: false });
        cookie(idCookie, window.posthog.get_distinct_id());
        syncSession(window.posthog.get_session_id());
        window.posthog.capture('$pageview');
        active = true;
        installBehavior();
        syncCart();
      }
      return;
    }
    if (loading) return;
    loading = true;
    const id = readCookie(idCookie) || crypto.randomUUID();
    cookie(idCookie, id);
    const script = document.createElement('script');
    script.src = 'https://us-assets.i.posthog.com/static/array.js';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onerror = () => {
      loading = false;
      console.warn('Talitha Koum analytics SDK could not load.');
    };
    script.onload = () => {
      if (!allowed()) { loading = false; return; }
      if (!window.posthog?.init) {
        loading = false;
        console.warn('Talitha Koum analytics SDK is unavailable.');
        return;
      }
      window.posthog.init(token, {
        api_host: 'https://us.i.posthog.com',
        ui_host: 'https://us.posthog.com',
        defaults: '2026-05-30',
        bootstrap: { distinctID: readCookie(idCookie) || id, isIdentifiedID: false },
        persistence: 'cookie',
        cross_subdomain_cookie: false,
        secure_cookie: true,
        person_profiles: 'never',
        capture_pageview: false,
        capture_pageleave: true,
        autocapture: { dom_event_allowlist: ['click'], element_allowlist: ['a', 'button'] },
        mask_all_text: true,
        mask_all_element_attributes: true,
        capture_exceptions: false,
        disable_session_recording: false,
        capture_performance: { web_vitals: true, network_timing: false },
        disable_surveys: true,
        enable_recording_console_log: false,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '*',
          blockSelector: 'iframe, .ph-no-capture, [data-posthog-block], a[href^="mailto:"], a[href^="tel:"]',
          recordCrossOriginIframes: false,
          maskCapturedNetworkRequestFn: () => undefined
        },
        before_send: scrub,
        loaded: (sdk) => {
          ready = true;
          loading = false;
          sdk.register({ store: 'talithakoum.com', integration: 'tk-shopify-v1' });
          sdk.onSessionId((sessionId) => { syncSession(sessionId); syncCart(); });
          syncConsent();
        }
      });
    };
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  function initialize() {
    if (window.Shopify?.customerPrivacy) return syncConsent();
    if (!window.Shopify?.loadFeatures) {
      console.warn('Talitha Koum analytics is waiting for the Shopify privacy API.');
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) console.warn('Talitha Koum analytics could not read consent.');
      else syncConsent();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
